import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

/**
 * Wraps the /terminal rebuild namespace (KAN-72). Admins and beta testers
 * pass in production; development is open so the shell can be exercised
 * without a seeded auth session. Old routes are never wrapped in this.
 */
export default function RebuildGate({ children }) {
  const { isAuthenticated, isAdmin, betaTestingFlag } = useAuth();

  if (process.env.NODE_ENV === 'development') {
    return children;
  }

  if (!isAuthenticated || (!isAdmin() && !betaTestingFlag)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
